import { Alert } from 'antd'
import { menuBuilderGpReviewCopy as copy } from 'src/constants/menuBuilderCopy'

const RecipeEconomicsStaleHint = ({ lineSum, persistedCostPerRecipe }) => {
  if (
    !Number.isFinite(Number(persistedCostPerRecipe)) ||
    !Number.isFinite(Number(lineSum))
  ) {
    return null
  }

  return (
    <Alert
      type='warning'
      showIcon
      style={{ marginBottom: 12 }}
      message={copy.staleEconomicsTitle}
      description={copy.staleEconomicsDescription
        .replace('{lineSum}', Number(lineSum).toFixed(2))
        .replace('{headerCost}', Number(persistedCostPerRecipe).toFixed(2))}
    />
  )
}

export default RecipeEconomicsStaleHint
